module.exports = __webpack_public_path__ + "img/品牌成员单位.ba5c8492.jpg";